import { EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { InsightsJobActions } from '.';
import { JobStatus } from '../../services/api.services';
import { Job, TrackedJob, TrackedJobEntities } from './types';

export interface InsightsJobsState {
  trackedJobs: EntityState<TrackedJob>;
};

export const initialState: InsightsJobsState = {
  trackedJobs: TrackedJobEntities.getInitialState({ total: 0 })
};

const insightsJobsReducer = createReducer(
  initialState,


  on(InsightsJobActions.getState, (state, { id }) => {
    return state;
  }),

  on(InsightsJobActions.getStateSuccess, (state, { id, job }) => {
    let trackedJob = state.trackedJobs.entities[id];

    return {
      ...state,

      trackedJobs: TrackedJobEntities.updateOne({
        id: id,
        changes: {
          job,
          getStateFailures: 0,
          getStateError: null
        }
      }, state.trackedJobs)
    };
  }),

  on(InsightsJobActions.getStateFailure, (state, { id, error }) => {
    let trackedJob = state.trackedJobs.entities[id];

    let failures = trackedJob.getStateFailures + 1;

    return {
      ...state,

      trackedJobs: TrackedJobEntities.updateOne({
        id: id,
        changes: {
          getStateFailures: failures,
          getStateError: error
        }
      }, state.trackedJobs)
    };
  }),


  on(InsightsJobActions.onStarted, (state, { id }) => {
    return state;
  }),

  on(InsightsJobActions.onCompleted, (state, { id, getStateFailed }) => {
    return {
      ...state,

      trackedJobs: TrackedJobEntities.updateOne({
        id: id,
        changes: {
          completed: true,
          getStateFailed: getStateFailed,
        }
      }, state.trackedJobs)
    };
  }),


  on(InsightsJobActions.startTracking, (state, { id, options }) => {
    return {
      ...state,

      trackedJobs: TrackedJobEntities.upsertOne({
        ...options,
        jobId: id,
        job: null,
        completed: false,
        getStateFailed: false,
        getStateFailures: 0,
        getStateError: null,
      }, state.trackedJobs)
    };
  }),

  on(InsightsJobActions.stopTracking, (state, { id }) => {
    return {
      ...state,
      trackedJobs: TrackedJobEntities.removeOne(id, state.trackedJobs)
    };
  }),
);

export function InsightsJobsReducer(state: InsightsJobsState | undefined, action: Action) {
  return insightsJobsReducer(state, action);
}
